<!-- Reviews Table UI with search, filter, sort, and pagination -->
<div>
  @if (canSyncReviews()) {
    <div class="flex justify-end mb-2">
      <button mat-icon-button
              [disabled]="syncing() || reviewsStore.loading()"
              (click)="syncReviews()"
              matTooltip="Sync reviews">
        <mat-icon>sync</mat-icon>
      </button>
    </div>
  }

    <div>
      <table
        mat-table
        [dataSource]="dataSource"
        matSort
        [matSortActive]="sortActive"
        [matSortDirection]="sortDirection"
        matSortStart="desc"
        (matSortChange)="sortData($event)">
        <!-- Commented At Column -->
        <ng-container matColumnDef="commentedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="!bg-blue-100">{{ "app.review.commentedAt" | translate }}</th>
          <td mat-cell *matCellDef="let review" class="!bg-gray-100">{{ review.commentedAt | date }}</td>
        </ng-container>
        <!-- Rating Column -->
        <ng-container matColumnDef="rating">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="!bg-blue-100">{{ "app.review.rating" | translate }}</th>
          <td mat-cell *matCellDef="let review">{{ review.rating }}</td>
        </ng-container>
        <!-- Responded At Column -->
        <ng-container matColumnDef="respondedAt">
          <th mat-header-cell *matHeaderCellDef mat-sort-header class="!bg-blue-100">{{ "app.review.respondedAt" | translate }}</th>
          <td mat-cell *matCellDef="let review" class="!bg-gray-100">{{ review.respondedAt ? (review.respondedAt | date) : '-' }}</td>
        </ng-container>
        <!-- Dealer Name Column -->
        <ng-container matColumnDef="locationId">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.dealer" | translate}}</th>
          <td mat-cell *matCellDef="let review">{{ review.dealerName }}</td>
        </ng-container>
        <!-- Author Name Column -->
        <ng-container matColumnDef="authorName">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.author" | translate}}</th>
          <td mat-cell *matCellDef="let review" class="!bg-gray-100">{{ review.authorName }}</td>
        </ng-container>
        <!-- Response Column -->
        <ng-container matColumnDef="response">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.review" | translate}}</th>
          <td mat-cell *matCellDef="let review">
            <div
              [matTooltip]="review.response || ''"
              matTooltipPosition="above"
              [matTooltipDisabled]="!(review.response && review.response.length > 50)">
              {{ review.response | slice:0:50 }}{{ review.response && review.response.length > 50 ? '...' : '' }}

            </div>
          </td>
        </ng-container>
        <!-- Comment Column -->
        <ng-container matColumnDef="comment">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.comment" | translate}}</th>
          <td mat-cell *matCellDef="let review">
            <div
              [matTooltip]="review.comment || ''"
              matTooltipPosition="above"
              [matTooltipDisabled]="!(review.comment && review.comment.length > 50)">
              {{ review.comment | slice:0:50 }}{{ review.comment && review.comment.length > 50 ? '...' : '' }}
            </div>
          </td>
        </ng-container>
        <!-- isResponded Column -->
        <ng-container matColumnDef="isResponded">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.responded" | translate}}</th>
          <td
            mat-cell
            *matCellDef="let review"
            class="!bg-gray-100">
            <div class="flex w-full items-center justify-center">
              @if (review.responded){
                  <mat-icon color="primary">check_circle</mat-icon>
              }@else{
                <button  mat-flat-button color="primary" (click)="openReplyForm(review)">
                  {{ "app.review.reply" | translate }}
                </button>
              }
            </div>
          </td>
        </ng-container>

        <ng-container matColumnDef="tag">
          <th mat-header-cell *matHeaderCellDef class="!bg-blue-100">{{ "app.review.tags" | translate }}</th>
          <td
            mat-cell
            *matCellDef="let review"
            class="!bg-gray-100">

            <div class="flex w-full items-center justify-center">
              <button   mat-flat-button color="primary" (click)="openTagsForm(review)">
                @if (review.labels?.length > 0){
                    {{ review.labels.map(label => label.name).join(', ') }}
                }@else{
                    {{ "app.review.no.tags" | translate }}
                }
              </button>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="displayedColumns" class="!bg-blue-100"></tr>
        <tr mat-row *matRowDef="let review; columns: displayedColumns;"></tr>

      </table>
      @if (reviewsStore.loading()) {
        <mat-progress-bar mode="indeterminate"></mat-progress-bar>
      }
      @if (pageToken) {
        <div class="flex justify-center w-full mt-4">
          <button mat-raised-button color="primary" (click)="fetchReviews(true)" [disabled]="reviewsStore.loading()">
            {{ "app.review.load.more" | translate }}
          </button>
        </div>
      }
    </div>


</div>
